import React, { useMemo } from "react";
import { Text, Icons, Button } from "@pushpress/shared-components";

interface SetupItemProps {
  title: string;
  instructionTitle: string;
  value: string[];
  loading?: boolean;
  buttonText: string;
  disabled?: boolean;
  completed?: boolean;
  stepNumber?: number;
  onClick?: () => void;
}

const SetupItem = (props: SetupItemProps) => {
  const {
    title,
    instructionTitle,
    value,
    loading,
    buttonText,
    disabled,
    stepNumber,
    completed = true,
    onClick,
  } = props;

  const values = useMemo(
    () =>
      value.map((str, index) => (
        <React.Fragment key={index}>
          {str}
          {index < value.length - 1 && <br />}
        </React.Fragment>
      )),
    [value],
  );

  return (
    <button
      onClick={onClick}
      className={`tw-bg-white tw-w-full tw-text-left tw-flex tw-items-center tw-justify-between tw-gap-2 sm:tw-gap-4 tw-flex-col sm:tw-flex-row tw-border-gray-300 tw-border tw-py-4 tw-px-4 tw-rounded-lg tw-transition-colors tw-duration-200 tw-ease-in-out ${
        disabled
          ? "tw-pointer-events-none"
          : "hover:tw-bg-gray-100  hover:tw-bg-gray-100/50 hover:tw-cursor-pointer"
      }`}
    >
      <div className="tw-flex tw-items-center tw-w-full sm:tw-w-auto">
        {completed ? (
          <div className="tw-w-full">
            <div className="tw-flex tw-justify-between tw-items-center tw-w-full">
              <Text weight="600" variant="heading-5" color="black">
                {title}
              </Text>
              {!disabled && <Icons.CaretRight className="sm:tw-hidden" />}
            </div>

            <div className="tw-h-2" />

            <Text variant="body-lg" color="wolf-600">
              {values}
            </Text>
          </div>
        ) : (
          <Text weight="400" variant="heading-5" color="black">
            {`${stepNumber}. ${instructionTitle}`}
          </Text>
        )}
      </div>

      {!disabled && completed && (
        <Icons.CaretRight className="tw-hidden sm:tw-block" />
      )}

      {!completed && (
        <div className="tw-w-full sm:tw-w-1/3">
          <Button
            fullWidth
            loading={loading}
            text={buttonText}
            buttonType="primary"
            size="medium"
          />
        </div>
      )}
    </button>
  );
};

export default SetupItem;
